<app-alert></app-alert>
<section class="panel panel-default">

    <div class="card-header">
        <title>MBP-4A Register of Contracts or agreements with any related party under section 188 or in which any director is concerned or interested under sub- section (2) of section 184</title>
        <span class="cat__core__title">
            <strong id="pageTitle"> MBP-4A Register of Contracts or agreements with any related party under section 188 or in which any director is concerned or interested under sub- section (2) of section 184</strong>
        </span>

        <span style="float: right">
            <!-- <a routerLink="/mbp4List"> -->
                <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
                    <i class=" fa fa-chevron-circle-left"></i>
                    Back
                </button>
            <!-- </a> -->
        </span>
        <!-- <span style="float:right">
            <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabflag">
              <span>
                <i class="fa fa-save"></i>Generate Output</span>
            </button>
      </span> -->
    </div>


    <div class="row">
        <div class="col-lg-12" id="mbp4aTabContainer">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" href="javascript: void(0);" data-toggle="tab"
                        data-target="#transactiontype" role="tab" [appHasPermission]="{'Url': '/register/mbp4List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp4List'}">
                        Transaction Type
                    </a>
                </li>
                <li class="nav-item">
                    <a *ngIf="restrictTabflag" class="nav-link " href="javascript: void(0);" data-toggle="tab" data-target="#detailsofvoting"
                        role="tab" [appHasPermission]="{'Url': '/register/mbp4List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp4List'}">
                        Details of voting on such resolution
                    </a>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="transactiontype" role="tabcard">
                    <form [formGroup]='mbpForm' class="well" (document:click)="c.close()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <label>Transaction Type<span _ngcontent-c2="" style="color: red;">*</span></label>
                                    <div class="form-group">
                                       
                                            <select _ngcontent-c2="" class="form-control " 
                                            [formControl]="mbpForm.controls['transactionType']" (change)="changeTransactionType(mbpForm.controls['transactionType'].value)"
                                            style="padding:6px;">
                                                                                                                         
                                            <option _ngcontent-c2="" value="" [selected]="true" >
                                              Select any one
                                            </option>
                                            <option _ngcontent-c2="" value="contract" >
                                              Contract
                                            </option>
                                            <option _ngcontent-c2="" value="arrangement">
                                                Arrangement
                                            </option>
                                           
                                            </select>
                                           
                                            
                                      

                                    </div>
                                    
                                    <div
                                    *ngIf="mbpForm.controls['transactionType'].invalid && mbpForm.controls['transactionType'].touched"
                                    class="form-control-error-custom">
                                    Transaction type is required</div>
            
                                    </div>

                               
                                <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="mbpForm.controls.transactionType.value == 'contract'">
                                    <label>Date of Contract</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control"
                                            [formControl]="mbpForm.controls['dateOfContract']"
                                            [(ngModel)]="dateOfContractModel" style="padding:6px;z-index: 0;"
                                            placeholder="dd-mm-yyyy" name="dateOfContract" ngbDatepicker
                                            #mbp="ngbDatepicker" (click)="mbp.toggle()">
                                        <button class="input-group-addon" (click)="mbp.toggle()"
                                            type="button">
                                            <span class="fa fa-calendar"
                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                        </button>
                                       
                                       
                                    </div>
                                    <div
                                    *ngIf="mbpForm.controls['dateOfContract'].hasError('required') && mbpForm.controls['dateOfContract'].touched"
                                    class="form-control-error-custom">
                                       Date of Contract is required</div>
                                  </div>
                                  <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="mbpForm.controls.transactionType.value == 'arrangement'">
                                        <label>Date of Arrangement</label>
                                        <span _ngcontent-c2="" style="color: red;">*</span>
                                        <div class="input-group" (click)="$event.stopPropagation()">
                                            <input class="form-control"
                                                [formControl]="mbpForm.controls['dateOfArrangement']"
                                                [(ngModel)]="dateOfArrangementModel" style="padding:6px;z-index: 0;"
                                                placeholder="dd-mm-yyyy" name="dateOfArrangement" ngbDatepicker
                                                #mbp="ngbDatepicker" (click)="mbp.toggle()">
                                            <button class="input-group-addon" (click)="mbp.toggle()"
                                                type="button">
                                                <span class="fa fa-calendar"
                                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                            </button>
                                            
                                            
                                        </div>
                                        <div
                                            *ngIf="mbpForm.controls['dateOfArrangement'].hasError('required') && mbpForm.controls['dateOfArrangement'].touched"
                                             class="form-control-error-custom">
                                             Date of Arrangement is required</div>
                                      </div>
                                
                                
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Name of the party with which contract is entered
                                        into<span _ngcontent-c2="" style="color: red;">*</span></label>
                                    <input type="text" class="form-control" maxLength="50" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="mbpForm.controls['nameOfTheParty']">
                                   
                                    <div
                                    *ngIf="mbpForm.controls['nameOfTheParty'].hasError('pattern') && mbpForm.controls['nameOfTheParty'].touched"
                                    class="form-control-error-custom">
                                    Name of the party is invalid
                                   </div>
                                   <div
                                    *ngIf="mbpForm.controls['nameOfTheParty'].hasError('required') && mbpForm.controls['nameOfTheParty'].touched"
                                    class="form-control-error-custom">
                                    Name of the party is required
                                   </div>
                                    
                                </div>
                           
                        </div>
                            <div class="row">
                                <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
                                    <label>Any director interested?<span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                    <div class="form-group">
                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="changeyes" type="radio"
                                                [formControl]="mbpForm.controls['anyDirectorInterested']"
                                                style="position: absolute" value="true" name="change" (click)="showchangeYesClick()"
                                                class="form-check-input"  (change)="funDirector(mbpForm.controls['anyDirectorInterested'].value)"
                                                style="padding:6px;">
                                            <label for="changeyes" ng-model="Yes" style="padding: 0 29px 0px 0px">Yes</label>
                                        </div>
                                        <div class="md-radio md-radio-inline" style="display: inline-block">
                                            <input id="changeno" type="radio"
                                                [formControl]="mbpForm.controls['anyDirectorInterested']" (click)="hidechangeyesClick()"
                                                style="position: absolute" value="false" name="change"  (change)="funDirector(mbpForm.controls['anyDirectorInterested'].value)"
                                                class="form-check-input">
                                            <label for="changeno" ng-model="No">No</label>
                                        </div>
                                    </div>
                                   
                                    <div
                                    *ngIf="mbpForm.controls['anyDirectorInterested'].hasError('pattern') && mbpForm.controls['anyDirectorInterested'].touched"
                                    class="form-control-error-custom">
                                    Any director interested is invalid
                                   </div>
                                   <div
                                    *ngIf="mbpForm.controls['anyDirectorInterested'].hasError('required') && mbpForm.controls['anyDirectorInterested'].touched"
                                    class="form-control-error-custom">
                                    Any director interested is required
                                   </div>
                                </div>
                                <div class="form-group col-md-4 col-sm-6 col-xs-12"
                                    *ngIf="showchangeYes">
                                    <label class="form-control-label">Relation of party with director<span
                                            _ngcontent-c2="" style="color: red;">*</span></label>
                                    <textarea class="form-control" maxLength="50" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="mbpForm.controls['relationOfPartyWithDirector']"></textarea>
                                    

                                   <div *ngIf="mbpForm.controls['relationOfPartyWithDirector'].hasError('required') && mbpForm.controls['relationOfPartyWithDirector'].touched" class="form-control-error-custom">
                                    Relation of party with director is required
                                   </div>
                                  <div *ngIf="(mbpForm.controls['relationOfPartyWithDirector'].hasError('pattern') || mbpForm.controls['relationOfPartyWithDirector'].hasError('maxlength')) && mbpForm.controls['relationOfPartyWithDirector'].touched"
                                  class="form-control-error-custom">
                                  Relation of party with director is invalid
                                  </div>
                                    
                                </div>

                                

                                <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12"  *ngIf="showchangeYes">
                                    <label class="form-control-label" for="l0">Name of the interested director<span
                                        _ngcontent-c2="" style="color: red;">*</span></label>
                                 
                                      <select [formControl]="mbpForm.controls['nameOfTheInterestedDirector']" class="form-control" style="padding: 6px;"> 
                                            <option value="">Select any one</option>  
                                            <option *ngFor="let director of masterDirectorList" value="{{director.FirstName + ' '+ director.LastName}}">  
                                                {{director.FirstName + " "+ director.LastName}}
                                            </option> 
                                      </select>
                                      <div
                                      *ngIf="mbpForm.controls['nameOfTheInterestedDirector'].hasError('required') && mbpForm.controls['nameOfTheInterestedDirector'].touched"
                                      class="form-control-error-custom">
                                      Name of the interested director is required
                                     </div>
                                   </div>
                                  

                            </div>

                    
                            
                            <div class="row">
                                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="showchangeYes">
                                    <label>Relation of party with company<span style="color: red;">*</span></label>
                                    <textarea class="form-control" maxLength="50" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="mbpForm.controls['relationOfPartyWithCompany']"></textarea>
                                   
                                    <div
                                    *ngIf="mbpForm.controls['relationOfPartyWithCompany'].hasError('pattern') && mbpForm.controls['relationOfPartyWithCompany'].touched"
                                    class="form-control-error-custom">
                                    Relation of party with company is invalid
                                   </div>
                                   <div
                                    *ngIf="mbpForm.controls['relationOfPartyWithCompany'].hasError('required') && mbpForm.controls['relationOfPartyWithCompany'].touched"
                                    class="form-control-error-custom">
                                    Relation of party with company is required
                                   </div>
                                    
                                </div>
                                
                                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                        <label >Nature of concern or interest<span style="color: red;">*</span></label>
                                        <textarea class="form-control" [formControl]="mbpForm.controls['natureOfConcernOrInterest']" (keydown)="noBlankSpaceAtStart($event)"
                                            maxlength="250"></textarea>
                                        

                                    <div
                                    *ngIf="mbpForm.controls['natureOfConcernOrInterest'].hasError('pattern') && mbpForm.controls['natureOfConcernOrInterest'].touched"
                                    class="form-control-error-custom">
                                    Nature of concern or interest is invalid
                                   </div>
                                   <div
                                    *ngIf="mbpForm.controls['natureOfConcernOrInterest'].hasError('required') && mbpForm.controls['natureOfConcernOrInterest'].touched"
                                    class="form-control-error-custom">
                                    Nature of concern or interest is required
                                   </div>
                                  </div>
                               <div  class="form-group col-md-4 col-sm-6 col-xs-12">
                                            <label>Principal terms and conditions</label>
                                            <textarea class="form-control" (keydown)="noBlankSpaceAtStart($event)"
                                                [formControl]="mbpForm.controls['principalTermsAndConditions']"
                                                maxlength="200"></textarea>
                                                <div
                                                *ngIf="mbpForm.controls['principalTermsAndConditions'].hasError('pattern') && mbpForm.controls['principalTermsAndConditions'].touched"
                                                class="form-control-error-custom">
                                                Principal terms and conditions is invalid
                                               </div>
                                </div>
                            </div> 

                            

                            <div class="row">
                                <div class="form-group col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Whether the transaction is at arm's length or not</label>
                                     <div class="form-group">
                                    
                                      <div class="md-radio md-radio-inline" style="display: inline-block">
                                        <input id="changeYes" type="radio" name="whetherTheTransaction" value="yes" style="position: absolute" class="form-check-input"
                                        [formControl]="mbpForm.controls['whetherTheTransaction'] ">
                                        <label for="changeYes" ng-model="Yes" style="padding: 0 29px 0px 18px;">Yes</label>
                                      </div>
                                      <div class="md-radio md-radio-inline" style="display: inline-block">
                                        <input  id="changeNo" type="radio" name="whetherTheTransaction" value="no" style="position: absolute" class="form-check-input"
                                        [formControl]="mbpForm.controls['whetherTheTransaction']">

                                        
                                        <label for="changeNo" ng-model="No" style="padding: 0 29px 0px 18px;">No</label>
                                      </div>

                                      
                                    
                                    <div
                                    *ngIf="mbpForm.controls['whetherTheTransaction'].hasError('pattern') && mbpForm.controls['whetherTheTransaction'].touched"
                                    class="form-control-error-custom">
                                    Whether the transaction is at arm's length or not is invalid
                                   </div>
                                   
                                </div>
                                </div>

                               
                                      <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                                            <label class="form-control-label">Date of approval at the meeting of the
                                                board</label>
                                            <div class="input-group" (click)="$event.stopPropagation()">
                                                <input class="form-control" 
                                                    [formControl]="mbpForm.controls['dateOfApproval']"
                                                    [(ngModel)]="dateOfApprovalModel" style="padding:6px;z-index: 0;"
                                                    placeholder="dd-mm-yyyy" name="dateOfApproval" ngbDatepicker
                                                    #c="ngbDatepicker" (click)="c.toggle();">
                                                <button class="input-group-addon" (click)="c.toggle();"
                                                    type="button">
                                                    <span class="fa fa-calendar"
                                                        style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                                </button>
                                               
                                            </div>
                                            <div
                                            *ngIf="mbpForm.controls['dateOfApproval'].hasError('pattern') && mbpForm.controls['dateOfApproval'].touched"
                                            class="form-control-error-custom">
                                            Date of approval at the meeting of the board is invalid
                                           </div>
                                        </div>
                            </div>

                        </div>
                        <div class="card-footer" align="right">
                            <div class="form-group" *ngIf="!restrictTabflag">
                                    <button class="btn btn-sm btn-primary" (click)="saveTransactionFormEntry()" type="button"
                                      [disabled]="!mbpForm.valid || disabledOnClick">
                                      <span id="saveUpdateDirector"> <i class="fa fa-save"></i>&nbsp; Save </span>
                                    </button>
                                  </div>
                                  <div class="form-group" *ngIf="restrictTabflag">
                                    <button class="btn btn-sm btn-primary" (click)="updateMbpData()" type="button"
                                      [disabled]="!mbpForm.valid || disabledOnClick">
                                      <span id="saveUpdateDirector"> <i class="fa fa-save"></i> &nbsp;Update </span>
                                    </button>
                                  </div>
                                </div>

                       
                    </form>
                </div>


                <div class="tab-pane" id="detailsofvoting" role="tabcard">
                     <form [formGroup]="detailsForm" class="well" (document:click)="a.close();b.close()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">No.of directors present in the meeting</label>
                                    <input type="text" class="form-control" maxLength="2" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="detailsForm.controls['noOfDirectorsPresentInTheMeeting']">
                                        <div
                                        *ngIf="detailsForm.controls['noOfDirectorsPresentInTheMeeting'].hasError('pattern') && detailsForm.controls['noOfDirectorsPresentInTheMeeting'].touched"
                                        class="form-control-error-custom">
                                        No.of directors present in the meeting is invalid
                                       </div>
                                       
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">Directors voting in favour </label>
                                    <input type="text" class="form-control" maxLength="2" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="detailsForm.controls['directorsVotingInFavour']">
                                        <div
                                        *ngIf="detailsForm.controls['directorsVotingInFavour'].hasError('pattern') && detailsForm.controls['directorsVotingInFavour'].touched"
                                        class="form-control-error-custom">
                                        Directors voting in favour is invalid
                                       </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">Directors voting against</label>
                                    <input type="text" class="form-control" maxLength="2" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="detailsForm.controls['directorsVotingAgainst']">
                                        <div
                                        *ngIf="detailsForm.controls['directorsVotingAgainst'].hasError('pattern') && detailsForm.controls['directorsVotingAgainst'].touched"
                                        class="form-control-error-custom">
                                        Directors voting against is invalid
                                       </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">Directors remaining neutral</label>
                                    <input type="text" class="form-control" maxLength="2" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="detailsForm.controls['directorsRemainingNeutral']">
                                        <div
                                        *ngIf="detailsForm.controls['directorsRemainingNeutral'].hasError('pattern') && detailsForm.controls['directorsRemainingNeutral'].touched"
                                        class="form-control-error-custom">
                                        Directors remaining neutral is invalid
                                       </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Date of the next meeting at which register was
                                        placed for signature</label>
                                    <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" 
                                            [formControl]="detailsForm.controls['dateOfTheNextMeeting']"
                                            [(ngModel)]="dateOfTheNextMeetingModel" style="padding:6px;z-index: 0;"
                                            placeholder="dd-mm-yyyy" name="dateOfTheNextMeetingdate" ngbDatepicker
                                            #a="ngbDatepicker" (click)="a.toggle()">
                                        <button class="input-group-addon" (click)="a.toggle()"
                                            type="button">
                                            <span class="fa fa-calendar"
                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                        </button>
                                        
                                    </div>
                                    <div
                                        *ngIf="detailsForm.controls['dateOfTheNextMeeting'].hasError('pattern') && detailsForm.controls['dateOfTheNextMeeting'].touched"
                                        class="form-control-error-custom">
                                        Date of the next meeting at which register was
                                        placed for signature is invalid
                                       </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Reference of specific items-(a) to (g) under
                                        subsection(1) of section 188</label>
                                    <input type="text" class="form-control" maxLength="50" (keydown)="noBlankSpaceAtStart($event)"
                                        [formControl]="detailsForm.controls['referenceOfSpecificItems']">
                                       
                                       <div
                                       *ngIf="detailsForm.controls['referenceOfSpecificItems'].hasError('pattern') && detailsForm.controls['referenceOfSpecificItems'].touched"
                                       class="form-control-error-custom">
                                       Reference of specific items-(a) to (g) under
                                       subsection(1) of section 188 invalid
                                      </div>
                                </div>
                            </div>
                            <div class="row">
                                 <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">Amount of contract<span _ngcontent-c2=""
                                            style="color: red;">*</span></label>
                                     
                                     <input type="text" class="form-control" [formControl]="detailsForm.controls['amountOfContract']" [value]="detailsForm.controls['amountOfContract'].value" maxlength="17" (keyup)="noBlankSpaceAtStart($event)" (keydown)="onlyTwoDecimal($event)">
                                  
                                 
                                   <div *ngIf="(detailsForm.controls['amountOfContract'].hasError('pattern') || detailsForm.controls['amountOfContract'].hasError('maxlength')) && detailsForm.controls['amountOfContract'].touched"
                                   class="form-control-error-custom">
                                   Amount of contract is invalid
                                   </div>
                                   <div
                                    *ngIf="detailsForm.controls['amountOfContract'].hasError('required') && detailsForm.controls['amountOfContract'].touched"
                                    class="form-control-error-custom">
                                    Amount of contract is required
                                   </div>


                                </div>
                                
                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label class="form-control-label">Date of shareholders approval,if any</label>
                                    <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control"
                                            [formControl]="detailsForm.controls['dateOfShareholdersApproval']"
                                            [(ngModel)]="dateOfShareholdersApprovalModel"
                                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                            name="dateOfShareholdersApprovaldate" ngbDatepicker #b="ngbDatepicker"
                                            (click)="b.toggle()">
                                        <button class="input-group-addon" (click)="b.toggle()"
                                            type="button">
                                            <span class="fa fa-calendar"
                                                style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                        </button>
                                    </div>
                                   
                                    <div
                                        *ngIf="detailsForm.controls['dateOfShareholdersApproval'].hasError('pattern') && detailsForm.controls['dateOfShareholdersApproval'].touched"
                                        class="form-control-error-custom">
                                        Date of shareholders approval is invalid
                                       </div>
                                </div>
                            </div>
                          
                        </div> 
                        <div class="card-footer" align="right">
                                  <div class="form-group" *ngIf="addDetailsBtn">
                                    <button class="btn btn-sm btn-primary" (click)="saveDetailsFormEntry()" type="button"
                                      [disabled]="!detailsForm.valid || disabledOnClick">
                                      <span> <i class="fa fa-save"></i>&nbsp; Save </span>
                                    </button>
                                  </div>
                                  <div class="form-group" *ngIf="!addDetailsBtn">
                                    <button class="btn btn-sm btn-primary" (click)="saveDetailsFormEntry()" type="button"
                                      [disabled]="!detailsForm.valid || disabledOnClick">
                                      <span> <i class="fa fa-save"></i>&nbsp; Update </span>
                                    </button>
                                  </div>
                                </div>    
                                  
                        
                     </form>
                </div>

            </div>
        </div>
    </div>       
</section>
